import { render, staticRenderFns } from "./InventoryIdentification.vue?vue&type=template&id=1f59e0fc&scoped=true"
import script from "./InventoryIdentification.vue?vue&type=script&lang=js"
export * from "./InventoryIdentification.vue?vue&type=script&lang=js"
import style0 from "./InventoryIdentification.vue?vue&type=style&index=0&id=1f59e0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59e0fc",
  null
  
)

export default component.exports